import identity from 'transmute/identity';
import { ADD_RESULT, UPDATE_RESULT, UPDATE_RESULTS, REMOVE_RESULT, REMOVE_RESULTS, REPLACE_RESULT, REPLACE_RESULT_AFTER_SEARCH } from '../constants/ActionTypes';
const addResultAction = result => ({
  type: ADD_RESULT,
  payload: result
});
const updateResultAction = result => ({
  type: UPDATE_RESULT,
  payload: result
});
const updateResultsAction = results => ({
  type: UPDATE_RESULTS,
  payload: results
});
const removeResultAction = id => ({
  type: REMOVE_RESULT,
  payload: id
});
const removeResultsAction = ids => ({
  type: REMOVE_RESULTS,
  payload: ids
});
const replaceResultAction = ({
  idToReplace,
  replacementResult
}) => ({
  type: REPLACE_RESULT,
  payload: {
    idToReplace,
    replacementResult
  }
});
const replaceResultAfterSearchAction = ({
  idToReplace,
  replacementResult
}) => ({
  type: REPLACE_RESULT_AFTER_SEARCH,
  payload: {
    idToReplace,
    replacementResult
  }
});
const IndexUIActionsContainer = {
  create() {
    let _dispatch = identity;
    return {
      init: dispatch => _dispatch = dispatch,
      addResult: result => _dispatch(addResultAction(result)),
      updateResult: result => _dispatch(updateResultAction(result)),
      updateResults: results => _dispatch(updateResultsAction(results)),
      removeResult: id => _dispatch(removeResultAction(id)),
      removeResults: ids => _dispatch(removeResultsAction(ids)),
      replaceResult: ({
        idToReplace,
        replacementResult
      }) => _dispatch(replaceResultAction({
        idToReplace,
        replacementResult
      })),
      replaceResultAfterSearch: ({
        idToReplace,
        replacementResult
      }) => _dispatch(replaceResultAfterSearchAction({
        idToReplace,
        replacementResult
      }))
    };
  }
};
export default IndexUIActionsContainer.create();